import * as React from 'react';
import { Col, Row, ArticleHeading2, Body1, Body2 } from '@cian/ui-kit';
import {
  EHelpTextPosition,
  IQuestionLayoutProps,
  getFieldSize,
  FieldWrapper,
} from '@cian/frontend-request-form-widget';

import { IRequestFormQuestion } from '../../types/requestForm';

import * as styles from './styles.css';

export const CustomQuestionLayout: React.FC<IQuestionLayoutProps<IRequestFormQuestion>> = props => {
  const { question, error, actions, fieldMapper, above } = props;

  return (
    <div className={styles['container']} data-testid="questionLayout">
      <div>
        <ArticleHeading2>{question.title}</ArticleHeading2>
      </div>
      {question.helpText?.position === EHelpTextPosition.Above && (
        <div className={styles['description']}>
          <Body1 color="text-primary-default" display="inline">
            {question.helpText.text}
          </Body1>
        </div>
      )}
      {above && <div className={styles['above']}>{above}</div>}
      <div className={styles['answer']}>
        <Row>
          {question.fields.map(field => {
            const FieldComponent = fieldMapper(field.type);

            return (
              <Col key={field.name} {...getFieldSize(field)}>
                <FieldWrapper>
                  <div className={styles['field']}>
                    <FieldComponent {...field} />
                  </div>
                </FieldWrapper>
              </Col>
            );
          })}
        </Row>
      </div>
      {actions && <div className={styles['actions']}>{actions}</div>}
      {error && (
        <div className={styles['error']} data-testid="error">
          <Body2 display="inline" color="text-negative-default">
            {error}
          </Body2>
        </div>
      )}
      {question.helpText?.position === EHelpTextPosition.Below && (
        <div className={styles['footer']} data-testid="footer">
          {question.helpText.text}
        </div>
      )}
    </div>
  );
};

CustomQuestionLayout.displayName = 'CustomQuestionLayout';
